import axios from "axios";
import { logout } from "../lib/auth";
import { entryAnalysysTableColumn } from "../config/entryAnalysys";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

/** エントリー分析：複数表示区分を一括取得（display_categories パラメータ使用） */
export async function getEntryAnalysysMultiDivision(props: {
  [key: string]: number | string;
}, displayCategories: string[]): Promise<Record<string, {
  analysys: dataDifine[];
  columns: string[];
  all_data: dataDifine[];
}> | null> {
  try {
    const path = "entryAnalysys";
    const params: Record<string, string | number> = makeParams(entryAnalysysTableColumn.dataColumn, props);
    if (props.analysys_granularity_date_end_day !== undefined && props.analysys_granularity_date_end_day !== "")
      params.analysys_granularity_date_end_day = String(props.analysys_granularity_date_end_day);
    if (props.entry_cancell_base !== undefined && props.entry_cancell_base !== "")
      params.entry_cancell_base = String(props.entry_cancell_base);
    params.display_categories = displayCategories.join(",");
    const response = await axios.get(CONST.apiUrl + path, { params });
    if (!response.data.fetch_data || response.data.fetch_data === "null") return null;
    const result: Record<string, { analysys: dataDifine[]; columns: string[]; all_data: dataDifine[] }> = {};
    for (const [key, value] of Object.entries(response.data.fetch_data as Record<string, any[]>)) {
      const arr = value as any[];
      if (arr.length > 0 && arr[0].full_result) {
        result[key] = {
          analysys: arr[0].full_result.data || [],
          columns: arr[0].full_result.analysys_columns || [],
          all_data: arr[0].full_result.all_data || [],
        };
      }
    }
    return result;
  } catch (error) {
    return null;
  }
}

//  エントリー分析取得（集計項目 entry_aggregation_item をAPIに送る）
export async function getEntryAnalysys(props: {
  [key: string]: number | string;
}) {
  try {
    const path = "entryAnalysys";
    const params: Record<string, string | number> = makeParams(entryAnalysysTableColumn.dataColumn, props);
    // ダッシュボードKPIと同一期間・同一定義にするため dataColumn にないパラメータを付与
    if (props.analysys_granularity_date_end_day !== undefined && props.analysys_granularity_date_end_day !== "")
      params.analysys_granularity_date_end_day = String(props.analysys_granularity_date_end_day);
    if (props.entry_cancell_base !== undefined && props.entry_cancell_base !== "")
      params.entry_cancell_base = String(props.entry_cancell_base);
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const analysys: dataDifine[] = response.data.fetch_data[0].full_result.data;
    const columns: string[] =
      response.data.fetch_data[0].full_result.analysys_columns;
    const all_data: dataDifine[] =
      response.data.fetch_data[0].full_result.all_data;
    return { analysys, columns, all_data };
  } catch (error) {
    // logout();
  }
}

/** エントリー分析カレンダー・区分別内訳一括取得（accessDB2） */
export async function getEntryAnalysysBreakdown(props: {
  year: string | number;
  month: string | number;
  price_type?: string;
  aggregation_item?: string;
  filter_product_name?: string;
  high_rank_company_name?: string;
  product_name?: string;
  sale_company_name?: string;
  sale_company_group_name?: string;
  sale_account_name?: string;
}): Promise<{
  daily: { name: string; 合計: number }[];
  product: { name: string; 合計: number }[];
  partner: { name: string; 合計: number }[];
  account: { name: string; 合計: number }[];
} | null> {
  try {
    const path = "entryAnalysysBreakdown";
    const params: Record<string, string | number> = {
      year: props.year,
      month: props.month,
    };
    if (props.price_type) params.price_type = props.price_type;
    if (props.aggregation_item) params.aggregation_item = props.aggregation_item;
    if (props.filter_product_name) params.filter_product_name = props.filter_product_name;
    if (props.high_rank_company_name) params.high_rank_company_name = props.high_rank_company_name;
    if (props.product_name) params.product_name = props.product_name;
    if (props.sale_company_name) params.sale_company_name = props.sale_company_name;
    if (props.sale_company_group_name) params.sale_company_group_name = props.sale_company_group_name;
    if (props.sale_account_name) params.sale_account_name = props.sale_account_name;
    const response = await axios.get(CONST.apiUrl2 + path, { params });
    if (!response.data.fetch_data) return null;
    return response.data.fetch_data as {
      daily: { name: string; 合計: number }[];
      product: { name: string; 合計: number }[];
      partner: { name: string; 合計: number }[];
      account: { name: string; 合計: number }[];
    };
  } catch (error) {
    return null;
  }
}
